import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Oportunidad/Edit/{id}',
  alias: ['/sistema/crm/Oportunidad/Edit'],
  documento: 'crm',
  filas: ['136'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/OportunidadController.cs:443',
} satisfies RutaProd;
